import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../api/store";
import { RemarksState } from "./remark.state";

const initialState: RemarksState = {
    actNote: '',
    isShow: false,
    actNoteForCFE: '',
    isEditNoteForCFE: false,
    isEditNoteForProposal: false,
    isEditingNoteForProposal: false,
    noteForProposalAct: {
        isShow: false,
        notesProposal: '',
        showCKEdit: false,
        copyNotes: '',
    }
};

const remarksSlice = createSlice({
    name: "remarksSlice",
    initialState,
    reducers: {
        setNotes: (state, action: PayloadAction<{type: 'pdf' | 'cfe', value: string}>) => {
            const { type, value } = action.payload;
            if(type === 'cfe') {
                state.actNoteForCFE = value;
            } else {
                state.actNote = value;
            }
        },
        setIsShowToPDF: (state, action: PayloadAction<boolean>) => {
            state.isShow = action.payload;
        },
        setIsEditRemarks: (state, action: PayloadAction<{type: "cfe" | "proposal", value: boolean}>) => {
            const { type, value } = action.payload;
            if(type === 'cfe') {
                state.isEditNoteForCFE = value;
                return;
            }
            if(type === 'proposal') {
                state.isEditNoteForProposal = value;
                return;
            }
        },
        setIsEditingNotesForProposal: (state, action: PayloadAction<boolean>) => {
            state.isEditingNoteForProposal = action.payload;
        },
        setNoteForProposalAct: (state, action: PayloadAction<Partial<typeof state.noteForProposalAct>>) => {
            state.noteForProposalAct = {
                ...state.noteForProposalAct,
                ...action.payload,
            };
        },
        resetNoteForProposalAct: (state) => {
            state.noteForProposalAct = {
                isShow: false,
                notesProposal: "",
                showCKEdit: false,
                copyNotes: "",
            };
        },

        resetRemarks: (state) => {
            state.actNote = '';
            state.isShow = false;
            state.actNoteForCFE = '';
            state.isEditNoteForCFE = false;
            state.isEditNoteForProposal = false;
        }
    },
});

export const { 
    setNotes,
    setIsShowToPDF,
    setIsEditRemarks,
    setIsEditingNotesForProposal,
    setNoteForProposalAct,
    resetNoteForProposalAct,
    resetRemarks,
} = remarksSlice.actions;

export const selectActNotePDF = (state: RootState) => state.remarksSlice.actNote;
export const selectIsShowActNotePDF = (state: RootState) => state.remarksSlice.isShow;
export const selectActNoteForCFE = (state: RootState) => state.remarksSlice.actNoteForCFE;
export const selectIsEditNotesForCFE = (state: RootState) => state.remarksSlice.isEditNoteForCFE;
export const selectIsEditNotesForProposal = (state: RootState) => state.remarksSlice.isEditNoteForProposal;
export const selectIsEditingNotesForProposal = (state: RootState) => state.remarksSlice.isEditingNoteForProposal;
export const selectNoteForProposalAct = (state: RootState) => state.remarksSlice.noteForProposalAct;

export default remarksSlice.reducer;
